import * as React from 'react';
import {Checkbox} from '@deviceinsight/ng-ui-basic-components';
import type {Rule} from '../../modules/ruleengine/types';
import RuleDeactivationWarning from './RuleDeactivationWarning';

type Props = {
	rule: Rule;
	onChange: (arg0: Rule) => void;
	disabled: boolean;
};

const RuleActiveCheckbox = ({rule, onChange, disabled}: Props) => {
	const [isActive, setIsActive] = React.useState(rule.active);

	return (
		<div>
			<RuleDeactivationWarning deactivatedBySystem={rule.deactivatedBySystem}></RuleDeactivationWarning>
			<Checkbox
				type="toggle"
				value={isActive}
				toggleSmall
				disabled={disabled}
				onChange={() => {
					setIsActive(!isActive);
					onChange({...rule, active: !isActive});
				}}
			/>
		</div>
	);
};

export default RuleActiveCheckbox;
